import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import English from "./language/english.json";
import Arabic from "./language/arabic.json";
import Russian from "./language/rusi.json";
import Turkish from "./language/turkish.json";
// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  fa: {
    translation: {
      //home
      "I am culprit":"من مقصر هستم",
      "I am losses":"من زیاندیده هستم",
      //button
      "ready to visit": "آماده بازدید",
      "i accident" : "تصادف کردم",
      "Button tooltip alert": "با نگه داشتن دکمه پس از 3 ثانیه درخواست شما ثبت خواهد شد!",
      "Accept and continue" : "تایید و ادامه",
      "Pay and continue" : "پرداخت و ادامه",
      "Reject":"انصراف",
      //modal
      "GpsModal title":"کارشناس محترم جناب {{name}} عزیز",
      "GpsModal message":"با ابراز خرسندی از همکاری با شما، اپلیکیشن بالن درجهت تسریع در ارجاع پرونده ها متناسب با شرایط شما نیازمند دریافت موقعیت مکانی تان می باشد. ",
      "GpsModal btn how to turn on":"چجوری روشن کنم؟",
      "GpsModal btn i know how to turn on":"بلدم، روشن میکنم",
      "RuleModal we need your acceptance":"با ابراز خرسندی از همکاری با شما، با توجه به افزایش فعالیت اپلیکیشن بالن مبنی بر شرکت های بیمه گر و تعداد پرونده ها و مناطق تحت پوشش و همچنین طرح های جدید پیش رو جهت ادامه همکاری با شما نیازمند تایید قوانین و مقررات قانونی شرکت توسط شما می باشیم .",
      "NotifModal i read and accept":"را خواندم و قبول دارم.",
      "NotifModal Accepted message":"توسط شما تایید شده است",
      "NotifModal your company paied for you":"بیمه گذار محترم تمام هزینه کارشناسی آنلاین برای شما توسط شرکت بیمه {{userInsurance}} پرداخت شده است و این خدمات به صورت کاملا رایگان برای شما انجام خواهد شد.",
      "NotifModal your company doesnt paied for you":"بیمه گذار محترم متاسفانه شرکت بیمه {{userInsurance}} هزینه کارشناسی آنلاین را برای شما پرداخت ننموده است , در صورت تمایل به استفاده از خدمات کارشناسی آنلاین ، هزینه را طبق تعرفه بیمه مرکزی(با احتساب مالیات ارزش افزوده) پرداخت نمایید.",

      //notification
      "Follow up on my files":"پیگیری پرونده های من",
      "My notifications":"اعلان های من",

      //header
      "Balance of digital wallet" : "موجودی کیف پول دیجیتال",
      "rial" : "ریال",
      "Inventory increase":"افزایش موجودی",
      "personal info edit" : "ویرایش اطلاعات شخصی",
      "digital wallet":"کیف پول دیجیتال ",
      "my process" : "کارشناسی های من",
      "my files": "پرونده های من" ,
      "my issued visit": "بازدید های صدور من",
      "Visiting the issuance of body insurance policy" : "بازدید صدور بیمه نامه بدنه",
      "Ready work": "آماده فعالیت",
      "I am on leave":"مرخصی هستم",
      "Terms and rules": "شرایط و قوانین",
      "Language": "زبان",
      "Contact" :"تماس با ما",
      "Login to panel": "ورود به پنل",
      "Education":"آموزش",
      "Logout":"خروج",
      "Farsi":"فارسی",
      "English": "English",
      "Arabic":"العربية",
      "Russian":"Русский",
      "Turkish":"Türkçe",
      "Turn on your GPS access": "لطفا برای امکان فعالیت ، موقعیت مکانی خود را روشن کنید.",
      "To accessing your GPS check setting":"لطفا برای دسترسی به موقعیت تنظیمات خود را مجددا بررسی کنید",
      "Expert online alert":"عزیز ، شما در وضعیت آماده فعالیت قرار گرفته اید. پلتفرم هوشمند درخواست های بازدید متناسب با شرایط شما را ارجاع خواهد داد.از همکاری با شما خرسندیم .",
      "Expert offline alert":"عزیز ، شما در وضعیت مرخصی قرار گرفته اید. توجه داشته باشید از هم اکنون پلتفرم هوشمند پرونده بازدیدی به شما ارجاع نخواهد داد. حال خوب شما آرزوی ماست .",
      //waiting
      "Please turn on your Gps":"لطفا موقعیت خود را روشن کنید",
      "Contact with company":"تماس با مرکز",
      "Accident notification in the hour":"اعلام تصادف در ساعت ",
      "Wait for call":"منتظر تماس ما باشید",
      "Dont forget":"فراموش نکنید",
      "Emergency":"اورژانس",
      "Police":"پلیس",
      "Fire station":"آتش نشانی",
      "Securing the scene of the accident":"ایمن سازی محل حادثه",
      "Keep calm":"حفظ آرامش",
      //editProfile
      "User info": "مشخصات کاربر",
      "Car info": "مشخصات خودرو",
      "Insurance info": "مشخصات بیمه",
      "First name": "نام",
      "Last name": "نام خانوادگی",
      "Shaba number":"شماره شبا مالک",
      "Hesab number":"شماره حساب بانک ملت",
      "National ID":"کد ملی",
      "Birth date":"تاریخ تولد",
      "Marital status": "وضعیت تاهل",
      "Married":"متاهل",
      "Single":"مجرد",
      "Emergency contact number":"شماره تماس اضطراری",
      "Complete postal address":"نشانی کامل پستی",
      "License type":"نوع گواهی نامه",
      "License number": "شماره گواهی نامه",
      "Plate type":"نوع پلاک",
      "Chassis number":"شماره شاسی",
      "Motor number":"شماره موتور",
      "Car color":"رنگ خودرو",
      "Plate":"پلاک",
      "Car type":"نوع خودرو",
      "Car brand": "برند خودرو",
      "Car model":"مدل خودرو",
      "I have body insurance?": "بیمه بدنه دارم؟",
      "Third insurance number":"شماره بیمه نامه ثالث",
      "Third insurance company":"شرکت بیمه نامه ثالث",
      "Third insurance start date":"تاریخ شروع بیمه نامه ثالث",
      "Third insurance end date":"تاریخ پایان بیمه نامه ثالث",
      "Body insurance number":"شماره بیمه نامه بدنه",
      "Body insurance company":"شرکت بیمه نامه بدنه",
      "Body insurance start date":"تاریخ شروع بیمه نامه بدنه",
      "Body insurance end date":"تاریخ پایان بیمه نامه بدنه",
      "License image":"تصویر گواهی نامه",
      "Back License image":"تصویر پشت گواهی نامه",
      "Vehicle card image": "تصویر کارت خودرو",
      "Back vehicle card image": "تصویر پشت کارت خودرو",
      "Third insurance image": "تصویر بیمه نامه ثالث",
      "Body insurance image":"تصویر بیمه نامه بدنه",
      "Needed images": "تصاویر مورد نیاز",
      "All pages of ID card":"کلیه صفحات شناسنامه",
      "Front and back of car license":"پشت و روی گواهینامه",
      "Front and back of ID card":"پشت و روی کارت ملی (یا رسید پستی)",
      "Duty end card":"کارت پایان خدمت",
      "The last degree":"آخرین مدرک تحصیلی",
      "Sign image":"تصویر امضا روی کاغذ سفید",
      "Profile edited successfully":"مشخصات با موفقیت ویرایش شد",
      "Enter the correct account id":"شماره حساب بانک ملت را به درستی وارد کنید",
      "Unchangable info alert":" اطلاعات شما در وضعیت غیرقابل تغییر میباشد، در صورت نیاز به تغییر اطلاعات خود با ستاد بالن تماس حاصل فرمایید.",

      //wallet
      "Cleared":"تسویه شده",
      "Total price":"مبلغ کل",
      "Gift":"تشویق",
      "Penalty":"جریمه",
      "Distance":"مسافت",
      "Kilometr":"کیلومتر",
      "Current Account":"حساب جاری",
      "Fees":"حق الزحمه ",
      "Legal deductions":"کسورات قانونی",
      "Balance of financial performance":"تراز عملکرد مالی",
      "Due price":"مبلغ قابل پرداخت",
      "Transaction list":"لیست تراکنش ها",
      "Price charge":"شارژ مبلغ",
      "Checkout":"تسویه حساب",
      "ََAward":"هدیه",
      //report single
      "File Details":"مشخصات پرونده",
      "File Num":"شماره پرونده",
      "Date and Time of accident":"تاریخ و ساعت ثبت حادثه",
      "Date and Time of register":"تاریخ و ساعت ثبت",
      "File type":"نوع پرونده",
      "File image":"تصاویر پرونده",
      "Full name":"نام و نام خانوادگی",
      "Phone num":"شماره تماس",
      "Address":"آدرس",
      "Owner name":"نام مالک",
      "Owner type":"نوع مالک",
      "Report expert": "گزارش کارشناسی",
      "Accessories list":"لیست قطعات",
      "Uknown":"نامشخص",
      "Wage list": "لیست اجرت ها ",
      "Extra list":"لیست اضافات ",
      "Deduct list":"لیست کسورات ",
      "Archives list":"بازدید مجدد",
      "Complements":"متمم",
      "Total":"مجموع",
      "Total accessories":"جمع قطعات",
      "Total wages":"جمع اجرت ها",
      "Total extra":"جمع اضافات",
      "Total deduct":"جمع کسورات",
      "Final total":"جمع کل",
      "Vehicle type":"نوع وسیله",
      "Vehicle brand":"برند وسیله",
      "Vehicle model":"مدل وسیله",
      "Vehicle color":"رنگ وسیله",
      "Vehicle value":"ارزش وسیله",
      "Leave us a message":"برای ما پیام بگذارید",
      "Confirm and get the money":"تایید و دریافت خسارت",
      "Cancle get money":"انصراف از دریافت خسارت",
      "Confirm report message":"پرونده در تاریخ {{date}} توسط زیاندیده تایید شده است",
      "Cancle report message":"شما در  تاریخ {{date}} از دریافت خسارت انصراف دادید",
      "Edit":"ویرایش",
      "Health visit":"بازدید سلامت",
      "Give damage accessories":"ارائه داغی",
      ///>>report image
      "Coroukie image":"کروکی",
      "Crash image":"مواضع و قطعات ",
      "Damage image":"صحنه حادثه",
      "License":"گواهینامه",
      "License back":"پشت گواهینامه",
      "Vehicle card":" روی کارت وسیله",
      "Vehicle card back":"پشت کارت وسیله",
      "Third insurance":"بیمه شخص ثالث",
      "Body insurance":"بیمه بدنه",
      "Front vehicle":"جلوی وسیله",
      "Back vehicle":"عقب وسیله",
      "Left side vehicle":"پهلوی چپ وسیله",
      "Right side vehicle":"پهلوی راست وسیله",
      
      //report list
      "All state":"همه وضعیت ها",
      "File":"پرونده",
      "Accident":"حادثه",
      "State":"وضعیت",
      "Date":"تاریخ",
      "Operation":"عملیات",
      "Experting":"در حال کارشناسی",
      "Waiting to check":"در انتظار بررسی",
      "Ready to visit again":"آماده بازدید مجدد",
      "Visit again done":"بازدید مجدد شد",
      "Ready to give damage accessories":"آماده تحویل داغی",
      "Give damage accessories done":"داغی تحویل شد",
      "Ready to health visit":"آماده بازدید سلامت",
      "Health visit done":"بازدید سلامت شد",
      "Ready to council":"آماده شورا",
      "Technical council":"شورای فنی",
      "Waiting to confirmation1":"در انتظار تایید 1",
      "Waiting to confirmation2":"در انتظار تایید 2",
      "Waiting to confirmation3":"در انتظار تایید 3",
      "Confirm":"تایید",
      "Disapproval":"رد",
      "Paied":"پرداخت شد",
      "Closed":"مختومه",
      "Visit again" :"بازدید مجدد",
      "Document check":"بررسی مستندات",
      "Waiting to balon confirm":"آماده تایید بالن",
      "Waiting to assesstor confirm":"آماده تایید ارزیاب",
      "Waiting to insurance confirm":"آماده تایید بیمه گر",
      "Send in confirm":"ارسال تایید شده",
      "Send in reject":"ارسال رد شده",
      "Send in over due":"ارسال بیش از تعهد",
      //edit report
      "File edited successfully":"پرونده با موفقیت ویرایش شد",
      "Does your experting complete?":"آیا کارشناسی شما جهت ارسال به ستاد تکمیل شده است؟",
      "Edit file":"ویرایش پرونده",
      
      //register list
      "Requested":"درخواست شده",
      "Wait to confirm":"منتظر تایید",
      "Review and audit":"بررسی و ممیزی",
      "Confirmed":"تایید شده",
      "Issued":"صادر شده",
      "Identification":"شناسه",
      
      //register single
      "Visit type":"نوع بازدید",
      "Name of applicant":"نام متقاضی",
      "Insurer fullname":"نام بیمه گزار",
      "Insurer national id":"کد ملی بیمه گزار",
      "Vehicle info":"مشخصات وسیله",
      "Extra accessories list":"لیست قطعات اضافه",
      "Damage accessories list":"لیست قطعات دارای خسارت",
      "Exchange accessories list":"لیست قطعات تعویضی",
      "Nothing registered":"موردی ثبت نشده است",
      "Vehicle plate":"پلاک انتظامی",
      "Motor image":"عکس موتور",
      "Kilometr image":"صفحه کیلومتر روشن",
      "Dashboard":"داشبورد",
      "Cabin":"داخل کابین",
      "Green card":"سند یا برگه سبز",
      "Car ceiling":"سقف وسیله",
      "Trunk":"داخل صندوق عقب",
      "Tire":"مشخصات لاستیک",
      "Using":"کاربری",
      "Engraved chassis number":" شاسی حک شده",
      "Engraved chassis plate":" شاسی پرچ شده",
      "Front glass":"شیشه جلو",
      "Plate chassis":"سینی پلاک",
      "Back glass":"شیشه عقب",
      "Under trunk":"سینی کف صندوق عقب",
      "Front Left vehicle" : "پهلوی جلو چپ",
      "Back Left vehicle" :"پهلوی عقب چپ",
      "Back Right vehicle" :"پهلوی عقب راست",
      "Front Right vehicle":"پهلوی جلو راست",
      "Ring Front Left":"چرخ جلو چپ",
      "Ring Front Right":"چرخ جلو راست",
      "Ring Back Left":"چرخ عقب چپ",
      "Ring Back Right":"چرخ عقب راست",
      "Police Report":"گزارش پلیس(کروکی)",
      
      //register
      //>>data
      "Complete register feilds":"کاربر گرامی با سپاس از اعتماد شما، لطفا جهت تشکیل پرونده اطلاعات درخواستی را تکمیل نمایید.",
      "For someone else":"برای شخص دیگر",
      "Insurer first name":"نام بیمه گزار",
      "Insurer last name":"نام خانوادگی بیمه گزار",
      "Insurer phone number":"شماره همراه بیمه گزار",
      "Request type":"نوع درخواست",
      "Insurance company":"شرکت بیمه",
      "Agent code":"کد نمایندگی",
      "Personal":"شخصی",
      "Taxi":"تاکسی",
      "Online taxi":"آژانس و تاکسی آنلاین",
      "Suburban taxi":"تاکسی برون شهری",
      "Personal passenger":"مسافربر شخصی",
      "To issue an insurance policy":"جهت صدور بیمه نامه",
      "Capital Increase":"افزایش سرمایه",
      "Installation of additional non-fabric accessories with an invoice":"نصب لوازم اضافی غیر فابریک با فاکتور",
      "Installation of additional non-fabric accessories without invoice":"نصب لوازم اضافی غیر فابریک بدون فاکتور",
      "Visit to confirm the renovation":"بازدید تایید بازسازی",
      "Complete required fields":"فیلد های اجباری {{err}} را پر کنید.",
      /// new items added /////
      "Register modal title":"کاربر گرامی جهت درخواست بازدید صدور موارد زیر را رعایت فرمایید:",
      "Register modal 1-clause":"تمیز بودن خودرو",
      "Register modal 2-clause":"روشنایی کافی محل تصویر برداری",
      "Register modal 3-clause":"خودرو خارج از پارکینگ یا هر فضای سربسته ای باشد",
      "Register modal 4-clause":"دقت در نحوه تصویر برداری و ارسال تمامی تصاویر درخواستی",
      //>>images
      "Register Uploading image":"کاربر گرامی لطفا جهت تکمیل پرونده تصاویر درخواستی را بارگذاری نمایید .",
      "Times left to upload register images":"فرصت باقی مانده برای بارگذاری تصاویر",
      "Image of accessories":"تصویر لوازم جانبی",
      "Images of damaged positions":"تصاویر مواضع دارای آسیب",
      "Upload reqired images":"عکس های اجباری {{error}} را بارگذاری کنید.",
      //>>video
      "Error upload video alert":"بارگذاری فیلم با خطا مواجه شد",
      "Successful upload video alert":"پرونده صدور شما تشکیل شد.با آرزوی روزی پر انرژی برای شما.",
      "Uploading video":"در حال آپلود ویدیو",
      "20 seconds video":"فیلم 20 ثانیه ای",
      "Upload video is required":"بارگذاری فیلم اجباری است",
      //contact box
      "Ways to support you":"در صورت نیاز به هرگونه پشتیبانی از طريق راه ارتباطی زیر در خدمت شما هستیم",
      "Phone call contact":"ارتباط از طریق تماس تلفنی",
      "We answer you as soon as possible":"در اسرع وقت پاسخگوی شما خواهیم بود",
      //about us
      "About us":"درباره ما",
      "About us text":" موسسه ارزیابی خسارت بالن فعال در زمینه کارشناسی و ارزیابی خسارت بیمه با رویکرد طرح های نوین و بی سابقه در کشور، مفتخر است تا  با ارائه اولین سیستم تمام آنلاین اعلام و ارزیابی خسارت مالی و جانی بیمه ای (وب سایت و اپلیکیشن) در کشور عزیزمان، گامی مهم در جهت تسریع ارائه خدمات بیمه ای به هم میهنان عزیز بردارد. موسسه ارزیابی خسارت بالن با هدف توسعه سیستم های برخط در حوزه بیمه، همواره در پی توسعه ایده های جدید در این زمینه جهت افزایش کیفیت خدمت رسانی به ایرانیان است. رسالت ما ایجاد استاندارد های به روز خدمت رسانی در صنعت بیمه کشور است.",
      //Maps
      "Select your location":"لطفا محل بازدید خودرو زیاندیده را مشخص کنید.",
      //expert map
      "Applicant":"درخواست کننده",
      "I reached my destination":"به مقصد رسیدم",
      "File description":"توضیحات پرونده",
      "Expert map accident title":" همکار محترم، جناب {{name}} پرونده {{insuranceType}} به شماره  {{fileNum}} جهت رسیدگی با مشخصات زیر به شما ارجاع شد.",
      "Expert map issued title":"همکار محترم، جناب {{name}} پرونده صدور به شماره {{fileNum}} {{fileType}} با مشخصات زیر به شما ارجاع شد.",
      //complete
      "Call and confirm the accident by the headquarters":"تماس و تایید تصادف توسط مرکز",
      "Send accident image report":"ارسال تصاویر گزارش حادثه",
      "Waiting":"منتظر",
      "Send image documents":"ارسال تصاویر مدارک",
      "Contact with expert":"تماس با کارشناس",
      "Expert info":"مشخصات کارشناس",
      "Dispatch Expert":"اعزام کارشناس",
      "Expert assignment":"تخصیص کارشناس",
      "Waiting for expert assignment":"شما در انتظار تخصیص کارشناس هستید",
      "Thanks for your patiance":"از شکیبایی شما سپاس گذاریم",
      "Select position in map":"انتخاب موقعیت در نقشه",
      "Send accident image":"ارسال تصاویر حادثه",
      "Sending positions and damaged parts":"ارسال مواضع و قطعات خسارت دیده ",
      "Send vehicle image":"ارسال تصاویر خودرو",
      //>>krouki
      "Coroukie report":"گزارش (کروکی)",
      //>>uploaddocs
      "Culprit docs":"مدارک مقصر",
      "Losses docs":"مدارک زیان دیده",
      "Car card":"کارت خودرو ",
      "Car back card":"پشت کارت خودرو",
      //>>carImage
      "Front car":"جلوی خودرو",
      "Back car":"پشت خودرو",
      "Right side car":"پهلوی راست خودرو",
      "Left side car":"پهلوی چپ خودرو",
      //>>crashImage
      "Damaged positions and parts":"مواضع و قطعات خسارت دیده",
      "Add damaged accessories":"افزودن مواضع و قطعات",
      //>>damageImage
      "The scene of the accident":"صحنه حادثه ",
      //Culprit deatils
      //>>userData
      "Driver full name":"نام کامل راننده",
      "Driver national id":"کد ملی راننده",
      "Driver info":"مشخصات راننده",
      //>>accident data
      "Accident address":"آدرس محل حادثه",
      "Accident info":"مشخصات حادثه",
      "Visit palce address":"آدرس محل بازدید",
      "Report Series":"سری گزارش",
      "Report serials":"سریال گزارش",
      "Report agent":"مامور گزارش",
      "Report agent code":"کد مامور گزارش",
      "Accident reason":"علت حادثه",
      "Accident type":"نوع تصادف",
      "Accident description":"شرح حادثه",
      "Croukie image":"تصاویر گزارش (کروکی)",
      "Financial":"مالی",
      "Life":"جانی",
      "Financial and life":"جانی و مالی",
      "173 clause":"عدم رعایت فاصله طولی (ماده 173)",
      "132 clause":"عدم رعایت فاصله عرضی (ماده 132)",
      "138 clause":"عدم رعایت حق تقدم (ماده 138)",
      "180 clause":"عدم توجه به جلو (ماده 180)",
      "129 and 120 clause":"عدم توانایی در کنترل وسیله نقلیه (ماده 120 و 129)",
      "126 clause":"تجاوز از سرعت مجاز (ماده 126)",
      "135 clause":"تجاوز به چپ ناشی از سبقت (ماده 135)",
      "118 and 119 clause":"انحراف به چپ (ماده 118 و 119)",
      "Right 118 and 119 clause":"انحراف به راست (ماده 118 و 119)",
      "122 clause":"عبور از محل ممنوع (ماده 122)",
      "155 clause":"حرکت با دنده عقب (ماده 155)",
      "200 clause":"نقص فنی مستمر وسیله (ماده 200)",
      "119 and 209 clause":"تغییر مسیر ناگهانی (ماده 119 و 209)",
      "84 and 86 clause":"نقض مقررات حمل بار (ماده 84 و 86)",
      "101 clause":"عبور از چراغ قرمز (ماده 101)",
      "154 clause":"دور زدن در محل ممنوع (ماده 154)",
      "152 clause":"گردش به طرز غلط (ماده 152 بند ب)",
      "Etcetra":"سایر",
      //>>card data
      "Owner full name":"نام کامل مالک",
      "Owner national id":"کد ملی مالک",
      "VIN":"VIN",
      "Produce year":"سال ساخت",
      "Current vehicle price rial":"قیمت روز وسیله (ریال)",
      "Damaged positions":"مواضع آسیب دیده",
      "Car Card image":"تصویر کارت خودرو",
      "Car back card image":"تصویر پشت کارت خودرو",
      //>>body data 
      "Body insurance info":"مشخصات بیمه نامه بدنه",
      "Third insurance info":"مشخصات بیمه نامه ثالث",
      //losses details
      "Please complete the feilds":"لطفا ابتدا فیلد های مورد نظر را پر نمایید!",
      "You can not delete the last option":"امکان حذف کردن آخرین مورد را ندارید!",
      "Type":"نوع",
      "Number":"تعداد",
      "General":"عمومی",
      "Special":"خصوصی",
      "Has herz?":"حرز دارد ؟",
      "Has":"دارد",
      "Has not":"ندارد",
      //expert images
      "Car image":"تصاویر خودرو",
      "Car chassis number":"شماره شاسی خودرو",
      //pricing
      "You already choose this accessories":"شما قبلا این قطعه را انتخاب کردید!",
      //expert waiting 
      "Check the authenticity of the vehicle":"اصالت وسیله نقلیه کنترل شود",
      "Knowledge, skill, ability":"دانش، مهارت، توانایی",
      "We are the servants of our countrymen":"ما خدمتگزار هموطنانمان هستیم",
      "End of visit":"پایان بازدید",
      "Initial visit":"بازدید اولیه",
      "Which case do you examine?":"کدام پرونده را کارشناسی می کنید؟",
      "Examine":"کارشناسی",
      //final pricing
      "Greeting expert alert":"همکار محترم، جناب {{fullname}} از این که ما را در کارشناسی این خسارت یاری نمودید سپاسگزاریم.با آرزوی روزی پر انرژی برای شما.",
      "Has your examine completed?":"آیا کارشناسی شما جهت ارسال به ستاد تکمیل شده است؟",
      "Yes,deliver":"بله، ارسال به ستاد",
      "No, i need time":"خیر، نیاز به بررسی بیشتر دارد",
      "Damage assessment report sheet":"برگه گزارش ارزیابی خسارت",
      "Accessory title":"عنوان قطعه",
      "Wage title":"عنوان اجرت",
      "Extra title":"عنوان اضافات",
      "Deduction title":"عنوان کسورات",
      //login component
      "Culprit and losses mobile had to be different":"شماره همراه مقصر و زیان دیده باید متفاوت باشد!",
      "Mobile number is not valid":"شماره موبایل وارد شده معتبر نمی باشد!",
      "Code is wrong":"کد اشتباه است!",
      "Enter your first name and last name":"نام و نام خانوادگی خود را وارد کنید!",
      "Please enter code":"لطفا کد را وارد کنید!",
      "Deliverd code":"کد ارسالی",
      "Send code again":"دریافت مجدد کد",
      "Login greeting":"سلام , خوش آمدید",
      "Please enter your mobile number":"لطفا شماره موبایل خود را وارد نمایید",
      "Enter culprit mobile number":"لذا لطفا شماره تلفن همراه مقصر حادثه را وارد نمایید",
      "Enter the code that send to culprit":"کد پیامک شده به تلفن همراه ",
      "Accident number":"حادثه به شماره '{{mobile}}' را وارد نمایید.",
      "Submit the request as":"شما در حال ثبت درخواست به عنوان",
      "Accident message":"حادثه هستید.",
      //payment
      "Code":"کد",
      "Payment invoice":"فاکتور پرداخت",
      "Pay":"پرداخت",
      "Payment gateways":"درگاه های پرداخت",
      "This gateway is unavailable, use another one":"این درگاه اکنون در دسترس نیست ، لطفا از درگاه دیگری استفاده نمایید .",
      "Your wallet stock":"موجودی کیف پول شما",
      "Control the price":"مبلغ وارد شده را کنترل نمایید.",
      "Enter your consider price in rial":"مبلغ مورد نظر را به ریال وارد نمایید",
      "Chosen price":"مبلغ انتخابی",
      "Expert wage":"حق الزحمه کارشناسی {{amount}} پرونده",
      "One":"یک",
      "Two":"دو",
      "Three":"سه",
      "Final amount payable":"مبلغ نهایی قابل پرداخت",
      "Tax":"هزینه مالیات بر ارزش افزوده",
      "The cost of assessments" :"هزینه ارزیابی طبق تعرفه بیمه مرکزی",
      //error
      "Please enter again":"لطفا دوباره وارد شوید.",
      "To solve this problem call hamrah bimeh":"برای حل این مشکل با بالن تماس بگیرید",
      "Call hamrah bimeh":"تماس با بالن",
      "Get it":"متوجه شدم",
      //review
      "Review greeting alert":"همکار محترم، از این که ما را در کارشناسی سلامت این خسارت یاری نمودید سپاسگزاریم.با آرزوی روزی پر انرژی برای شما.",
      
      //general
      "Prev step":"مرحله قبل",
      "Next step":"مرحله بعد",
      "Submit":"ثبت",
      "Third":"شخص ثالث",
      "Third only":"ثالث",
      "Body":"بدنه",
      "Culprit":"مقصر",
      "Losses":"زیاندیده",
      "Culprit info":"مشخصات مقصر",
      "Losses info":"مشخصات زیاندیده",
      "Completment image":"تصاویر تکمیلی",
      "Description":"توضیحات",
      "Description placeholder":"متن پیام",
      "Save":"ذخیره",
      "Search":"جستجو",
      "Watch":"مشاهده",
      "Uploading image":"در حال آپلود تصاویر",
      "Sample image":"عکس نمونه ",
      "Insurance":"بیمه نامه",
      "Percent":"درصد",
      "Degree":"درجه",
      "No":"خیر",
      "Yes":"بله",
      "Culprit car":"خودرو مقصر",
      "Losses car":"خودرو زیاندیده",
      "Optinal":"اختیاری",
      "Add":"افزودن",
      "Loading":"در حال بارگذاری",
      "License less":"فاقد گواهینامه",
      "Close":"بستن",
      "Ordinary":"معمولی",
      "Motor":"موتورسیکلت",
      "Free":"مناطق آزاد",
      "Next":"بعدی",
      "Prev":"قبلی",
      "Price":"قیمت",
      "Quality grade":"درجه کیفی",
      "Final confirm":"تایید نهایی",
      "Dear":"عزیز",
      "Images":"تصاویر",
      "Give damaged accessories":"تحویل داغی",
      "Expert name":"همکار محترم، جناب",
      "Dispatch file":"جهت رسیدگی به شما ارجاع شد.",
      "File number":"به شماره",
      //rule
      "Modal greatful message":"از ادامه همکاری با شما بسیار خرسندیم. به پاس قدردانی مبلغ {{price}}  ریال در کیف پول شما شارژ گردید.",
      "Continue":"ادامه",
      "Rules and condition title":"شرایط و قوانین استفاده از خدمات اپلیکیشن بالن",
      "Defenitaion and phases":"ماده ۱ - تعاریف و اصطلاحات",
      "Defenitaion and phases 1-1":"۱-۱- شرکت:  بالن که نسبت به ارائه خدمات در اپلیکیشن و وب سایت اقدام میکند.",
      "Rules and condition":"قوانین و مقررات",
      "Defenitaion and phases 1-2":"۱-۲- بالن: خدمات نرم‌افزاری که توسط شرکت به منظور تعیین خسارت های مالی در بیمه نامه های ثالث و بدنه (فقط مشتریان آن دسته از شرکت های بیمه که با شرکت بالن قرارداد همکاری داشته باشند) ارائه میشود",
      "Defenitaion and phases 1-3":"۱-3- اپلیکیشن: نرم‌افزار متعلق به شرکت که به منظور استفاده از خدمات 'بالن' ، حق استفادۀ موقت از آن برابر شرایط مندرج در قرارداد خصوصی و سند حاضر به کاربران یا طرف‌های تجاری شرکت اعطا می‌شود.",
      "Defenitaion and phases 1-4":"۱-4- قرارداد خصوصی: توافق کتبی یا الکترونیکی فی‌مابین شرکت و کارشناسان تعیین خسارت یا طرف‌های تجاری شرکت، جهت بهره‌برداری موقت از نرم‌افزار  بالن.",
      "Defenitaion and phases 1-5":"۱-5- کاربر: شخصی حقیقی یا حقوقی است اعم از کارشناس، ارگان دولتی یا شرکت های بیمه که از طریق اینترنت به اپلیکیشن یا وب سایت متصل و از خدمات اپلیکیشن یا وب سایت 'بالن' بهره‌مند می‌شود.",
      "Defenitaion and phases 1-6":"۱-6- کاربران: از کاربر کارشناس یا زیان دیده یا هر شخص حقیقی یا حقوقی که به عضویت اپلیکیشن یا وب سایت 'بالن' درآمده باشد.",
      "Defenitaion and phases 1-7":"۱-7- کاربر کارشناس: شخص حقیقی است که در اپلیکیشن کارشناسی 'بالن' جهت دریافت پیشنهاد تعیین خسارت عضو شده و دارای قرارداد کتبی با شرکت  بالن است.",
      "Defenitaion and phases 1-8":"۱-8- کاربر زیاندیده: شخص حقیقی یا حقوقی است که در اپلیکیشن زیاندیده 'بالن' برای ارسال درخواست کارشناسی خسارت مالی اتومبیل عضو شده است.",      "Defenitaion and phases 3 clause":"ماده ۳ - استفاده از 'بالن'",
      "Defenitaion and phases 1-9":"۱-9- طرف تجاری: اشخاص حقیقی و حقوقی که برابر قرارداد خصوصی از طریق عضویت در 'بالن' از خدمات اپلیکیشن یا وب سایت 'بالن' استفاده میکنند.",
      "Defenitaion and phases 1-10":"۱-۱0- حساب کاربری: حسابی است که اشخاص برای استفاده از خدمات “بالن” در اپلیکیشن ایجاد کرده‌اند.",
      "Defenitaion and phases 1-11":"۱-۱1- اطلاعات محرمانه: اطلاعاتی که توسط کاربران در اپلیکیشن یا وب سایت 'بالن' قرار داده می‌شود، اعم از اطلاعاتی که به صورت مستقیم از سوی کاربران وارد می‌شود و همچنین اطلاعاتی که به صورت خودکار و در نتیجۀ بهره‌برداری از خدمات اپلیکیشن یا وب سایت 'بالن' توسط شرکت یا طرف‌های تجاری تولید یا در اختیار شرکت قرار داده می‌شود.",
      "Defenitaion and phases 1-12":"۱-۱2- قوانین و مقررات جمهوری اسلامی ایران: قانون اساسی، قوانین عادی، آئین‌نامه‌های اجرایی، بخشنامه‌ها، دستورالعمل‌ها و کلیه ضوابط قانونی حاکم بر انجام موضوع قرارداد اعم از قانون بیمه اجباری شخص ثالث، بیمه بدنه، آئین نامه راهنمائی و رانندگی، قوانین بیمه مرکزی جمهوری اسلامی ایران و دستورالعمل ها و آیین نامه های آن.",
      "Defenitaion and phases 2 clause":"ماده ۲ - حساب کاربری",
      "Defenitaion and phases 3-1":"۳-1- با استفاده از خدمات 'بالن'، کاربران می‌پذیرند و موظف هستند که از خدمات ارائه شده برای انجام هیچ فعالیت غیر‌قانونی طبق قوانین جمهوری اسلامی ایران، خلاف شرع و مخالف با عرف جامعه استفاده نکنند.",
      "Defenitaion and phases 3-2":"۳-2- کاربران متعهد می‌شوند هیچ‌گاه از خدمات 'بالن' به صورتی که به 'بالن'، طرف تجاری و شرکای آن صدمه‌ای وارد کند استفاده نکنند. در صورتی که کاربران نسبت به سوءاستفاده از امکانات فراهم شده در خدمات 'بالن' در جهت منافع شخصی و یا آسیب مادی یا معنوی به منافع شرکت اقدام کنند، شرکت ضمن داشتن حق قطع خدمات و غیرفعال کردن حساب کاربری آنها، مجاز خواهد بود، با مراجعه به مراجع ذیصلاح، نسبت به پیگیری قانونی از جمله مطالبه خسارات وارده اقدام کند.",
      "Defenitaion and phases 3-3":"۳-3- کاربران می‌پذیرند که شرکت ممکن است از ارسال پیامک، ایمیل و یا Push Notification به عنوان راه ارتباطی با آنها استفاده کند. کاربران می‌توانند درخواست کنند که ارسال این پیام‌ها قطع شود، اما با انصراف از دریافت این پیام‌ها مشکلات احتمالی در استفاده از خدمات “بالن” را می‌پذیرند و ممکن است اطلاعات مقتضی را به موقع دریافت نکنند.",
      "Defenitaion and phases 3-4":"۳-4- مسئولیت تامین اینترنت و سخت‌افزار لازم و هم‌چنین پرداخت هزینه‌های مربوط به آن‌ها برای استفاده از خدمات “بالن” به عهدۀ کاربران است.",
      "Defenitaion and phases 3-5":"۳-5-کاربران متعهد می‌شوند پس از اتمام استفاده از خدمات ارائه شده در اپلیکیشن یا وب سایت، از اطلاعاتی که در نتیجۀ استفاده از خدمات “بالن” کسب کرده‌اند، هیچ‌گونه استفاده‌ای نکنند. طبعاً ذخیره کردن اطلاعات کاربران در دستگاه تلفن همراه یا به هر شیوۀ دیگر مغایر با قوانین “بالن” است. همچنین کاربران متعهد می‌شوند در طول زمان استفاده از خدمات و اپلیکیشن “بالن”، فقط در شرایط ضروری و به میزان مورد نیاز از اطلاعاتی که از کاربران ارائه شده است، استفاده کنند. استفادۀ کاربران از این اطلاعات باید مطابق با عرف جامعه و قوانین جمهوری اسلامی ایران باشد. در هر صورت اطلاعات مذکور به صورت امانت در اختیار کاربران قرار گرفته است و در صورت نقض تعهدات مذکور، شرکت و شخص ذینفع مجاز به پیگیری حقوقی و کیفری موضوع خواهد بود.",
      "Defenitaion and phases 3-6":"۳-6- کاربران متعهد به رعایت همۀ شرایط و قوانین، اصول اسلامی، شرعی، اخلاقی و اجتماعی جمهوری اسلامی ایران در هنگام استفاده از “بالن” هستند.",
      "Defenitaion and phases 3-6-1":"تبصره ۲- در صورت رد بی‌دلیل درخواست ارزیابی توسط کاربر کارشناس، شرکت می‌تواند نسبت به غیرفعال کردن حساب کاربری آنها به صورت موقت یا دائم اقدام کند.",
      "Defenitaion and phases 3-7":"۳-7- خدمات “بالن” به غیر از مواردی که منع قانونی دارد ممکن است با مشارکت خدمات شرکت‌ها یا طرف تجاری دیگری ارائه شود که شرکت “بالن” کنترلی روی آن‌ها ندارد. در چنین شرایطی کاربران می‌پذیرند که این خدمات، شرایط و قوانین مختص خود را دارند و “بالن” مسئولیتی در خصوص قوانین و خدمات این شرکت‌ها ندارد.",
      "Defenitaion and phases 2-1":"۲-۱- کاربران با ثبت‌نام در اپلیکیشن یا وب سایت 'بالن'، همچنین با هر بار استفاده از خدمات آن، می‌پذیرند که شرایط و قوانین حاضر را به صورت کامل مطالعه کرده و آن را با اطلاع کامل از شرایط و معانی‌اش پذیرفته‌اند. این شرایط و قوانین ممکن است در طول زمان تغییر کند. استفادۀ کاربران از اپلیکیشن یا وب سایت، پس از هر بار تغییر در شرایط و قوانین، به معنی پذیرش تغییرات مذکور است. این قوانین برای مطالعه کاربران در سایت و اپلیکیشن 'بالن' در دسترس است.",
      "Defenitaion and phases 2-2":"۲-۲- برای استفاده از خدمات اپلیکیشن یا وب سایت “بالن” لازم است که هر کاربر اعم از شخص حقیقی یا حقوقی یک حساب کاربری در اپلیکیشن یا وب سایت بسازد. تنها اشخاصی که بیش از ۱۸ سال سن دارند و واجد اهلیت قانونی هستند می‌توانند اقدام به ساخت حساب کاربری در اپلیکیشن کنند. کاربر مذکور برای استفاده از خدمات باید نام، نام خانوادگی و شماره همراه خود را در اپلیکیشن 'بالن' ثبت کند.",
      "Defenitaion and phases 2-3":"۲-۳- کاربران شخص حقوقی مکلف به معرفی نماینده (شخص حقیقی) برای ثبت‌نام در اپلیکیشن یا وب سایت هستند و اطلاعات این شخص حقوقی باید در اپلیکیشن قید شود.",
      "Defenitaion and phases 2-4":"۲-۴- هیچ یک از کاربران حق استفاده از ربات و نرم‌افزارهای مرتبط یا واسط را برای استفاده از اپلیکیشن اعم از احراز هویت، تکمیل اطلاعات، ارسال درخواست و غیره ندارند.",
      "Defenitaion and phases 2-5":"۲-۵- کاربران می‌پذیرند کلیه اطلاعات درخواستی اپلیکیشن را مطابق با واقعیت، صحیح و به‌‌روز وارد کنند و شخص کاربر مسئول عدم صحت و به‌ روز نبودن اطلاعات است. در صورت اثبات خلاف این موضوع، شرکت هیچ گونه مسئولیتی در مورد خسارات و مشکلات ناشی از عدم اعتبار اطلاعات اعلامی بر عهده نخواهد داشت.",
      "Defenitaion and phases 2-6":"۲-۶- کاربران متعهد می‌شوند که صرفا با شماره تلفن همراه متعلق به خود در اپلیکیشن ثبت‌نام کنند. در غیر این صورت در برابر شخص ذی‌نفع صاحب شماره تلفن همراه تماما مسئول بوده و شرکت به محض آگاهی از این موضوع مجاز خواهد بود نسبت به لغو عضویت و حساب کاربری اقدام کند.",
      "Defenitaion and phases 2-7":"۲-۷- هر شخص تنها می‌تواند یک حساب کاربری به عنوان کاربر 'زیاندیده' یا کاربر کارشناس داشته باشد. در صورتی که شرکت اطلاع یابد که به نام یک شخص اعم از حقیقی و یا حقوقی حساب‌های کاربری متعدد وجود دارد، مجاز خواهد بود نسبت به قطع خدمات و غیرفعال کردن حساب‌های کاربری مذکور اقدام کند.",
      "Defenitaion and phases 2-8":"۲-۸- مسئولیت همۀ فعالیت‌هایی که از طریق حساب کاربری اشخاص حقیقی و یا حقوقی در اپلیکیشن یا وب سایت 'بالن' یا سایر خدمات ارائه شده انجام می‌شود، به عهدۀ کاربران است. بنابراین مسئولیت اشخاص ثالث یا افراد غیر از کاربر که با استفاده از حساب کاربری وی از خدمات اپلیکیشن یا وب سایت استفاده می‌کند تماما متوجه کاربر صاحب حساب است.",
      "Defenitaion and phases 2-10":"۲-۱۰- کاربران حق ندارند به سایر اشخاص حقیقی و حقوقی اجازه استفاده از حساب کاربری خود را بدهند یا حساب خود را به شخص حقیقی یا حقوقی دیگری منتقل کنند. در مورد کاربر شخص حقوقی نیز، مسئولیت‌های قانونی بهره‌برداری از خدمات اپلیکیشن یا وب سایت “بالن” متوجه مدیران اشخاص حقوقی خواهد بود.",
      "Defenitaion and phases 2-11":"۲-۱۱- در شرایط خاصی ممکن است از کاربران برای استفاده از خدمات، درخواست احراز هویت شود، در این شرایطی اگر کاربران اطلاعات کافی در اختیار شرکت قرار ندهند، شرکت می‌تواند حساب کاربری آن‌ها را مسدود و از ارائه خدمات به نامبردگان خودداری کند.",
      "Defenitaion and phases 2-12":"۲-۱۲- ممکن است بنا به مورد و حسب صلاحدید شرکت و برای ارائه خدمات بهتر، از کاربران درخواست شود که اقدام به تکمیل اطلاعات از جمله اطلاعات کاربران (شامل نام و نام خانوادگی ، تاریخ تولد ، شماره تلفن همراه ، کد ملی ، شماره شبا و آدرس) و اطلاعات خودرو (شامل پلاک ، شماره شاسی ، شماره VIN ،شماره موتور و سال ساخت)، ارائه مدارک و یا اصلاح اطلاعات موجود کنند. در این صورت، کاربر متعهد به ارائه اطلاعات و یا اصلاح اطلاعات درخواستی در مدت اعلام و درخواست شده از سوی شرکت خواهد بود. در غیر این صورت شرکت می‌تواند حساب کاربری وی را مسدود کرده و از ارائه خدمات به کاربر مذکور خودداری کند.",
      "Defenitaion and phases 2-13":"۲-۱۳- اطلاعات کاربری کلیه کاربران نزد کاربر گیرنده اطلاعات، محرمانه بوده و در اختیار شخص ثالثی قرار نخواهد گرفت مگر در برابر قانون و مراجع قضایی ذیصلاح و هیچ یک از کاربران حق ندارند اطلاعات مربوط به حساب طرف مقابل را (اعم از مشخصات هویتی، شماره تماس، آدرس، عکس و غیره) ذخیره، یا منتشر کند و در دسترس دیگران قرار دهد.",
      //license type
      "International":"بین المللی",
      "Specific":"ویژه",
      "First grade":"پایه یک",
      "Second grade":"پایه دو",
      "Third grade":"پایه سه",
      //damaged positions
      "Ceiling":"سقف",
      "Back left":"عقب چپ",
      "Back right":"عقب راست",
      "Left side":"پهلوی چپ",
      "Right side":"پهلوی راست",
      "Front right":"جلو راست",
      "Front left":"جلو چپ",
      "Back":"عقب",
      "Front":"جلو",
      "Glass":"شیشه",
      //cabinTypes
      "Micro":"میکرو",
      "Sedan":"سدان",
      "HBack":"هاچبک",
      "Coupe":"کوپه",
      "Station":"استیشن",
      "Roadster":"رودستر",
      "Sport":"اسپورت",
      "Cross":"کراس",
      "Limo":"لیموزین",
      "Mini van":"مینی ون",
      "Bus":"اتوبوس",
      "Mini truck":"مینی تراک",
      "Camper":"کمپر",
      "SUV":"شاسی بلند",
      "Pickup":"پیکاپ",
      "Cabriolet":"کابریولت",
      "Musel":"ماسل",
      "Racer":"مسابقه ای",
      "Truck":"کامیون",
      "Heavy truck":"کامیون سنگین",
      //alphabets
      "A":"الف",
      "B":"ب",
      "C":"پ",
      "D":"ت",
      "E":"ث",
      "F":"ج",
      "G":"چ",
      "H":"ح",
      "I":"خ",
      "J":"د",
      "K":"ذ",
      "L":"ر",
      "M":"ز",
      "N":"ژ",
      "O":"س",
      "P":"ش",
      "Q":"ص",
      "R":"ض",
      "S":"ط",
      "T":"ظ",
      "U":"ع",
      "V":"غ",
      "W":"ف",
      "X":"ق",
      "Y":"ک",
      "Z":"گ",
      //register pricing
      "Final current vehicle price rial" :"قیمت نهایی روز وسیله(ریال)",
      "Visit place":"محل بازدید",
      "Exchange accessories":"لوازم تعویضی",
      "Damaged accessories":"لوازم دارای خسارت",
      "Fake accessories":"لوازم غیر فابریک",
      "Add extra description":"توضیحات آپشن های اضافه درج گردد.",
      "Add possible damages":"آسیب دیدگی های احتمالی در توضیحات درج گردد.",
      "Describe exchange accessories":"قسمت های بازسازی ویا تعویض شده شرح داده شود.",
      //success
      "Success page message":"با تشکر از اعتماد شما. تمامی مراحل رسیدگی به پرونده از طریق پیامک به شما اطلاع رسانی خواهد شد.  بالن درخدمت شماست.",
      "Success page file number":" شماره پرونده شما {{fileNum}} می باشد.",
      "Back to home":"بازگشت به صفحه اصلی",
      //imagepicker
      "First Two Page Birth Certificate" : "دو صفحه اول شناسنامه",
      "First Two Page Birth Certificate Image" : "تصویر دو صفحه اول شناسنامه ",
      "Second Two Page Birth Certificate" : "دو صفحه دوم شناسنامه",
      "Second Two Page Birth Certificate Image" : "تصویر دو صفحه دوم شناسنامه ",
      "Third Two Page Birth Certificate" : "دو صفحه سوم شناسنامه",
      "Third Two Page Birth Certificate Image" : "تصویر دو صفحه سوم شناسنامه ",
      "4th Two Page Birth Certificate" : "دو صفحه چهارم شناسنامه",
      "4th Two Page Birth Certificate Image" : "تصویر دو صفحه چهارم شناسنامه ",
      "ID card" : "روی کارت ملی" ,
      "ID card image" : " تصویر روی کارت ملی" ,
      "Back ID card" : "پشت کارت ملی" ,
      "Back ID card image" : " تصویر پشت کارت ملی" ,
      "Duty end card image":" تصویر کارت پایان خدمت",
      "The last degree image":" تصویرآخرین مدرک تحصیلی",
    }
  },
  ar: {
    translation : Arabic
  },
  en: {
    translation :English
  },
  ru: {
    translation : Russian
  },
  tu: {
    translation : Turkish
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    // lng: "fa", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

  export default i18n;